<div *ngIf="hrCards.length">
  <h3 >{{"cdchr"|translate}}</h3>
  <div class="flex-cards">
    <div class="card" *ngFor="let item of hrCards" (click)="onRowClick(item)">
      <div>{{ item.title }}</div>
      <div>{{ item.count }}</div>
    </div>
  </div>
</div>

<div *ngIf="accountantCards.length">
  <h3 >{{"cdcaccounting"|translate}}</h3>
  <div class="flex-cards">
    <div class="card" *ngFor="let item of accountantCards" (click)="onRowClick(item)">
      <div>{{ item.title }}</div>
      <div>{{ item.count }}</div>
    </div>
  </div>
</div>

<div *ngIf="stockCards.length">
  <h3>{{"cdcstore"|translate}}</h3>
  <div class="flex-cards">
    <div class="card" *ngFor="let item of stockCards" (click)="onRowClick(item)">
      <div>{{ item.title }}</div>
      <div>{{ item.count }}</div>
    </div>
  </div>
</div>